import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import MultipleFileInput from '@/components/Ui/MultipleFileInput'
import Constants from '@/utils/Constants'
import Validator from '@/utils/Validator'

export default {
  name: 'TypeOpinionaire',
  components: {
    MultipleFileInput
  },
  data () {
    return {
      input: {
        question: null,
        answerOptions01: null,
        answerOptions02: null,
        answerOptions03: null,
        answerOptions04: null,
        answerOptions05: null,
        answerOptions06: null,
        answerOptions07: null,
        answerOptions08: null,
        soundFile: null,
      },
      // 文字数制限
      limit: {
        title: 45, // 50,
      },
    }
  },
  mounted () {
    this.init()
    this.setValidate(this.formIsValid)
  },
  computed: {
    ...mapState({
      values: state => state.noticeForm.values
    }),
    ...mapGetters({
      permittedView: 'permission/permittedView',
    }),

    // placeholder
    placeholderTitle() {
      return '最大全角' + this.limit.title + '文字';
    },

    // validate
    formIsValid () {
      return Validator.validText(this.input.question) &&
        Validator.validText(this.input.answerOptions01) &&
        Validator.validText(this.input.answerOptions02)
    },

    // post用にjsonbを取得
    // アンケートは特殊なのでConfirmでjsonb化する
    // jsonb () {}
  },
  watch: {
    'input.question': function (to) {
      if (to) {
        this.input.question = Validator.charByteLimit(to, this.limit.title * 2)
      }
    },
    'input.answerOptions01': function (to) {
      if (to) {
        this.input.answerOptions01 = Validator.charByteLimit(to, 32)
      }
    },
    'input.answerOptions02': function (to) {
      if (to) {
        this.input.answerOptions02 = Validator.charByteLimit(to, 32)
      }
    },
    'input.answerOptions03': function (to) {
      if (to) {
        this.input.answerOptions03 = Validator.charByteLimit(to, 32)
      }
    },
    'input.answerOptions04': function (to) {
      if (to) {
        this.input.answerOptions04 = Validator.charByteLimit(to, 32)
      }
    },
    'input.answerOptions05': function (to) {
      if (to) {
        this.input.answerOptions05 = Validator.charByteLimit(to, 32)
      }
    },
    'input.answerOptions06': function (to) {
      if (to) {
        this.input.answerOptions06 = Validator.charByteLimit(to, 32)
      }
    },
    'input.answerOptions07': function (to) {
      if (to) {
        this.input.answerOptions07 = Validator.charByteLimit(to, 32)
      }
    },
    'input.answerOptions08': function (to) {
      if (to) {
        this.input.answerOptions08 = Validator.charByteLimit(to, 32)
      }
    },
    // 入力値が変更されたらモジュール全体のバリデート結果をstoreに保持
    input: {
      handler: function (to) {
        this.setValidate(this.formIsValid)
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({
      setValidate: 'noticeForm/setValidate'
    }),

    init () {
      Object.keys(this.input)
        .forEach(key => {
          if (this.values.inpDeliveryContents &&
            this.values.inpDeliveryContents[key]) {
            this.input[key] = this.values.inpDeliveryContents[key]
          }
        })
    },

    // ファイル登録
    changeFile ({index, file}) {
      this.input.soundFile = file
    },
  }
}
